import { IClusterIconData } from 'src/app/project-overview/project-overview-map/shared/models/cluster-icon-data.interface';
import { CalcUtil } from '../CalcUtil';
import { ProjectPhase } from '../model/general/ProjectPhase';
import { Technology } from '../model/general/Technology';
import { IGenericMap } from '../model/generic-map.interface';

export const iconPositionMap: IGenericMap<number> = {
  FIRST: 39,
  SECOND: 0,
  THIRD: -39,
};

export const projectIconDataMap: IGenericMap<IClusterIconData> = {
  [Technology.STORAGE]: {
    iconURL: '../assets/icons/technology/Storage-color.svg' as any,
    kpiIconURL: '../assets/icons/technology/Storage-color.svg' as any,
    greyIconURL: '../assets/icons/technology/Storage-grey.svg' as any,
    activeTypeFilterIcon:
      '../assets/icons/technology/RWE_storage-active.svg' as any,
    inActiveTypeFilterIcon:
      '../assets/icons/technology/RWE_storage-inactive.svg' as any,
    anchorHeight: iconPositionMap.THIRD,
    tooltipForActive:
      'Master Filter: Storage - Active. Click button to set to Inactive.',
    tooltipForInactive:
      'Master Filter: Storage - Inactive. Click button to set to Active.',
    type: Technology.STORAGE,
  },
  [Technology.SOLAR]: {
    iconURL: '../assets/icons/technology/Solar-color.svg' as any,
    kpiIconURL: '../assets/icons/technology/Solar-color.svg' as any,
    greyIconURL: '../assets/icons/technology/Solar-grey.svg' as any,
    activeTypeFilterIcon:
      '../assets/icons/technology/RWE_Photovoltaics-active.svg' as any,
    inActiveTypeFilterIcon:
      '../assets/icons/technology/RWE_Photovoltaics-inactive.svg' as any,
    anchorHeight: iconPositionMap.SECOND,
    tooltipForActive:
      'Master Filter: Solar - Active. Click button to set to Inactive.',
    tooltipForInactive:
      'Master Filter: Solar - Inactive. Click button to set to Active.',
    type: Technology.SOLAR,
  },
  [Technology.WIND_ONSHORE]: {
    iconURL: '../assets/icons/technology/Wind_Onshore-color.svg' as any,
    kpiIconURL: '../assets/icons/technology/Wind_Onshore.svg' as any,
    greyIconURL: '../assets/icons/technology/Wind_Onshore-grey.svg' as any,
    activeTypeFilterIcon:
      '../assets/icons/technology/RWE_Wind_onshore-active.svg' as any,
    inActiveTypeFilterIcon:
      '../assets/icons/technology/RWE_Wind_onshore-inactive.svg' as any,
    anchorHeight: iconPositionMap.FIRST,
    tooltipForActive:
      'Master Filter: Onshore Wind - Active. Click button to set to Inactive.',
    tooltipForInactive:
      'Master Filter: Onshore Wind - Inactive. Click button to set to Active.',
    type: Technology.WIND_ONSHORE,
  },
};

export const getProgressLabel = (phase: ProjectPhase) => {
  return phase === ProjectPhase.OPERATIONS
    ? 'Not Applicable'
    : (phase === ProjectPhase.CONSTRUCTION
      ? 'Grade of Completion'
      : 'Success Rate Cumulative');
}

export const getProgressValue = (phase: ProjectPhase, progress: number) => {
  return phase === ProjectPhase.OPERATIONS
    ? 'N/A'
    : ((progress || 0) * 100).toFixed(0);
}

export const getProgressUnit = (phase: ProjectPhase) => {
  return phase === ProjectPhase.OPERATIONS
    ? ''
    : '%'
}
